<template>
  <div id="app">
    <navbar></navbar>
    <keep-alive include="home,mods,mats,maps,dseek,tseek,pseek,news">
      <router-view/>
    </keep-alive>
    <!-- <mypuzzle></mypuzzle> -->
  </div>
</template>

<script>
  const navbar = ()=>import('components/content/navbar/navbar.vue')
  // const mypuzzle = ()=>import("components/content/mypuzzle/mypuzzle.vue")

  import {getcookies,getalllists,getuploadusers,getadvlist} from 'network/app.js'

  function newgetalllists(vue,spcial_v){
    getalllists().then(res=>{
      // console.log(res);
      vue.$store.state.homenewslists = [
        res.data.modsnewslists[0],
        res.data.modsnewslists[1],
        res.data.modsnewslists[2],
        res.data.matsnewslists[0],
        res.data.mapsnewslists[0]
      ]
      vue.$store.state.modsnewslists = res.data.modsnewslists
      vue.$store.state.matsnewslists = res.data.matsnewslists
      vue.$store.state.mapsnewslists = res.data.mapsnewslists
      spcial_v&&localStorage.setItem('spcial_v',spcial_v)
      localStorage.setItem('homenewslists',vue.utils.encrypt(JSON.stringify(vue.$store.state.homenewslists)))
      localStorage.setItem('modsnewslists',vue.utils.encrypt(JSON.stringify(vue.$store.state.modsnewslists)))
      localStorage.setItem('matsnewslists',vue.utils.encrypt(JSON.stringify(vue.$store.state.matsnewslists)))
      localStorage.setItem('mapsnewslists',vue.utils.encrypt(JSON.stringify(vue.$store.state.mapsnewslists)))
    })
  }

  export default {
    name:'app',
    data() {
      return {
      }
    },
    components:{
      navbar,
      // mypuzzle
    },
    created() {
      // console.log('app created');
      //在cookie上获取个数据
      // localStorage.clear();
      let spcial_v,local_spcial_v,mods_v,local_mods_v,mats_v,local_mats_v,maps_v,local_maps_v
      // try{
      //   spcial_v = JSON.parse(this.utils.getCookie('data_v')).spcial_v
      //   if(!spcial_v){throw new Error('spcial_v err')}
      //   this.utils.data_v.spcial_v = spcial_v
      // }catch(e){
      //   getcookies().then(res=>{
      //     spcial_v = JSON.parse(this.utils.getCookie('data_v')).spcial_v
      //     this.utils.data_v.spcial_v = spcial_v
      //     localStorage.setItem('spcial_v',spcial_v)
      //   })
      // }
      // try{
      //   mods_v = JSON.parse(this.utils.getCookie('data_v')).mods_v
      //   if(!mods_v){throw new Error('mods_v err')}
      //   this.utils.data_v.mods_v = mods_v
      // }catch(e){
      //   getcookies().then(res=>{
      //     mods_v = JSON.parse(this.utils.getCookie('data_v')).mods_v
      //     this.utils.data_v.mods_v = mods_v
      //     localStorage.setItem('mods_v',mods_v)
      //   })
      // }
      // try{
      //   mats_v = JSON.parse(this.utils.getCookie('data_v')).mats_v
      //   if(!mats_v){throw new Error('mats_v err')}
      //   this.utils.data_v.mats_v = mats_v
      // }catch(e){
      //   getcookies().then(res=>{
      //     mats_v = JSON.parse(this.utils.getCookie('data_v')).mats_v
      //     this.utils.data_v.mats_v = mats_v
      //     localStorage.setItem('mats_v',mats_v)
      //   })
      // }
      // try{
      //   maps_v = JSON.parse(this.utils.getCookie('data_v')).maps_v
      //   if(!maps_v){throw new Error('maps_v err')}
      //   this.utils.data_v.maps_v = maps_v
      // }catch(e){
      //   getcookies().then(res=>{
      //     maps_v = JSON.parse(this.utils.getCookie('data_v')).maps_v
      //     this.utils.data_v.maps_v = maps_v
      //     localStorage.setItem('maps_v',maps_v)
      //   })
      // }

      try{
        // console.log('本地');
        spcial_v = JSON.parse(this.utils.getCookie('data_v')).spcial_v
        if(!spcial_v){throw new Error('spcial_v err')}
        this.utils.data_v.spcial_v = spcial_v
        mods_v = JSON.parse(this.utils.getCookie('data_v')).mods_v
        if(!mods_v){throw new Error('mods_v err')}
        this.utils.data_v.mods_v = mods_v
        mats_v = JSON.parse(this.utils.getCookie('data_v')).mats_v
        if(!mats_v){throw new Error('mats_v err')}
        this.utils.data_v.mats_v = mats_v
        maps_v = JSON.parse(this.utils.getCookie('data_v')).maps_v
        if(!maps_v){throw new Error('maps_v err')}
        this.utils.data_v.maps_v = maps_v
        // console.log('本地',this.utils.data_v);
      }catch(e){
        // console.log('cookies');
        getcookies().then(res=>{
          // console.log('res',res);
          spcial_v = JSON.parse(this.utils.getCookie('data_v')).spcial_v
          this.utils.data_v.spcial_v = spcial_v
          localStorage.setItem('spcial_v',spcial_v)
          mods_v = JSON.parse(this.utils.getCookie('data_v')).mods_v
          this.utils.data_v.mods_v = mods_v
          localStorage.setItem('mods_v',mods_v)
          mats_v = JSON.parse(this.utils.getCookie('data_v')).mats_v
          this.utils.data_v.mats_v = mats_v
          localStorage.setItem('mats_v',mats_v)
          maps_v = JSON.parse(this.utils.getCookie('data_v')).maps_v
          this.utils.data_v.maps_v = maps_v
          localStorage.setItem('maps_v',maps_v)
          // console.log('cookies',this.utils.data_v);
        })
      }

      // console.log('首先',this.utils.data_v);

      //获取所有主题
      try{
        local_spcial_v = parseInt(localStorage.getItem('spcial_v'))
        this.$store.state.homenewslists = JSON.parse(this.utils.decrypt(localStorage.getItem('homenewslists')))
        this.$store.state.modsnewslists = JSON.parse(this.utils.decrypt(localStorage.getItem('modsnewslists')))
        this.$store.state.matsnewslists = JSON.parse(this.utils.decrypt(localStorage.getItem('matsnewslists')))
        this.$store.state.mapsnewslists = JSON.parse(this.utils.decrypt(localStorage.getItem('mapsnewslists')))
        if(spcial_v != local_spcial_v || this.$store.state.homenewslists.length==0 || this.$store.state.modsnewslists==0 || this.$store.state.matsnewslists==0 || this.$store.state.mapsnewslists==0){
          throw new Error('重新获取所有主题')
        }
      }catch(e){
        newgetalllists(this,spcial_v)
      }

      //获取上传用户对象
      // try{
      //   this.$store.state.uploaduserobj = JSON.parse(this.utils.decrypt(localStorage.getItem('uploaduserobj')))
      // }catch(e){
        getuploadusers().then(res=>{
          this.$store.state.uploaduserobj = JSON.parse(res.data.uploadusers)
          // localStorage.setItem('uploaduserobj',this.utils.encrypt(JSON.stringify(this.$store.state.uploaduserobj)))
        })
      // }

      //获取广告列表
      try{
        getadvlist().then(res=>{
          this.$store.state.advlist = JSON.parse(res.data.advlist)||[]
        }).catch((e)=>{})
      }catch(e){}
      //获取上一次登入的用户
      try{
        const yh = JSON.parse(this.utils.decrypt(localStorage.getItem('webyh')))
        // console.log('appyh',yh);
        if(Object.keys(yh).length >0){
          this.$store.state.username=yh.name||'图艺模块库会员'
          this.$store.state.sqlgrid=yh.sqlgrid
          this.$store.state.phone=yh.phone
          this.$store.state.role=yh.role
          this.$store.state.changed=yh.changed
          this.$store.state.passchanged=yh.passchanged
          this.$store.state.invitecode=yh.id
          this.$store.state.id=yh.id
          this.utils.userid = yh.id
          const userAgent = navigator.userAgent
          if(userAgent.includes('Electron')){
            sendlogin(yh,1).then(res=>{
              // console.log(res);
            })
          }
        }
      }catch(e){}
      document.addEventListener('click',(e)=>{
        if(this.$store.state.userpanelshow){
          this.$store.state.userpanelshow = false
        }
      })
    },
    
  }
</script>

<style>
  @import './assets/css/base.css';
  #app{
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
</style>
